import { createSlice } from '@reduxjs/toolkit';
import { UserNotificationsDetailStateType } from 'src/types/userNotificationsDetail';

const initialState: UserNotificationsDetailStateType = {
    data: null,
    loading: false,
    error: false,
};
export const userNotificationsDetailSlice = createSlice({
    name: 'userNotificationsDetail',
    initialState,
    reducers: {
        getUserNotificationsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getUserNotificationsDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        getUserNotificationsDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        updateUserNotificationsDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        updateUserNotificationsDetailFetchSuccess: (state, action) => {
            state.data = action.payload;
            state.loading = false;
        },
        updateUserNotificationsDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearUserNotificationsDetail: () => initialState,
    },
});

export const {
    getUserNotificationsDetailFetch,
    getUserNotificationsDetailFetchSuccess,
    getUserNotificationsDetailFetchFailure,
    updateUserNotificationsDetailFetch,
    updateUserNotificationsDetailFetchSuccess,
    updateUserNotificationsDetailFetchFailure,
    clearUserNotificationsDetail,
} = userNotificationsDetailSlice.actions;

export default userNotificationsDetailSlice.reducer;
